import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { split } from "@apollo/client";
import { WebSocketLink } from "@apollo/client/link/ws";
import { getMainDefinition } from "@apollo/client/utilities";
import "react-notifications/lib/notifications.css";
import { setContext } from "@apollo/client/link/context";
import { Provider } from "react-redux";
import { store } from "./Store/store";

import {
  ApolloProvider,
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  from,
} from "@apollo/client";
import { createUploadLink } from "apollo-upload-client";
import { getCookie } from "./Utils";

const wsLink = new WebSocketLink({
  uri: `wss://obeliski.ru/graphql`,
  options: {
    reconnect: true,
    connectionParams: {
      authToken: getCookie("obeliskiruru"),
    },
  },
});

const httpLink = createHttpLink({
  uri: "/graphql",
});

const uploadLink = createUploadLink({
  uri: "/graphql",
});

const authLink = setContext((_, { headers }) => {
  const token = getCookie("obeliskiruru");
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const link = split(
  ({ query }) => {
    const defs = getMainDefinition(query);
    return (
      defs.kind === "OperationDefinition" &&
      defs.operation &&
      defs.operation === "subscription"
    );
  },
  wsLink,
  from([authLink, uploadLink, httpLink])
);

// const persistedQueriesLink = createPersistedQueryLink({ sha256 });

const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        monuments: { keyArgs: ["name", "category"], merge: false },
        projects: {
          keyArgs: ["published", "favorite", "take"],
          merge: false
        },
      },
    },
  },
});

const client = new ApolloClient({
  link,
  cache,
  connectToDevTools: true,
});

ReactDOM.render(
  <ApolloProvider client={client}>
    <Provider store={store}>
      <App />
    </Provider>
  </ApolloProvider>,
  document.getElementById("ConstructorApp")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
